import { CasingFieldsEdit } from '../../../../types/form-types'
import { SetValue, ValidationErrors } from '../../../hooks/use-edit-form'
import LookupField from '../../wells/lookup-field'
import { preventChangeOnScroll } from '../../../services/form-utils'
import { FormField, FormFieldRow, TextInput } from '@msaf/core-react'

interface WellConstructionCasingsEditInterface {
  fields: Partial<CasingFieldsEdit>
  index?: number
  isLoading: boolean
  setValue: SetValue<CasingFieldsEdit>
  validationErrors?: ValidationErrors
}

export default function WellConstructionCasingsEdit({
  fields,
  isLoading,
  setValue,
  validationErrors = {},
}: WellConstructionCasingsEditInterface) {
  return (
    <>
      <FormField isSkeleton={isLoading} label='Type' labelId={`casingMaterialLabel-${fields.id}`}>
        <LookupField
          isSkeleton={isLoading}
          labelledBy={`casingMaterialLabel-${fields.id}`}
          fieldId='casingMaterial'
          value={`${fields.casingMaterial ?? ''}`}
          setValue={({ value }) => setValue('casingMaterial', value)}
        />
      </FormField>

      <FormFieldRow>
        <FormField
          isSkeleton={isLoading}
          label='Top(m)'
          htmlFor={`casingTop-${fields.id}`}
          validationMessages={validationErrors?.casingTop}
        >
          <TextInput
            isSkeleton={isLoading}
            type='number'
            onWheel={preventChangeOnScroll}
            id={`casingTop-${fields.id}`}
            value={`${fields.casingTop ?? ''}`}
            setValue={(value) => setValue('casingTop', value)}
            describedBy='casings-group'
            isInvalid={!!validationErrors?.casingTop}
          />
        </FormField>
        <FormField
          isSkeleton={isLoading}
          label='Bottom(m)'
          htmlFor={`casingBottom-${fields.id}`}
          validationMessages={validationErrors?.casingBottom}
        >
          <TextInput
            isSkeleton={isLoading}
            type='number'
            onWheel={preventChangeOnScroll}
            id={`casingBottom-${fields.id}`}
            value={`${fields.casingBottom ?? ''}`}
            describedBy='casings-group'
            setValue={(value) => setValue('casingBottom', value)}
            isInvalid={!!validationErrors?.casingBottom}
          />
        </FormField>
      </FormFieldRow>

      <FormFieldRow>
        <FormField
          isSkeleton={isLoading}
          label='Casing inside diameter(mm)'
          htmlFor={`casingInsideDiameter-${fields.id}`}
          validationMessages={validationErrors?.casingInsideDiameter}
        >
          <TextInput
            isSkeleton={isLoading}
            type='number'
            onWheel={preventChangeOnScroll}
            id={`casingInsideDiameter-${fields.id}`}
            value={`${fields.casingInsideDiameter ?? ''}`}
            describedBy='casings-group'
            setValue={(value) => setValue('casingInsideDiameter', value)}
            isInvalid={!!validationErrors?.casingInsideDiameter}
          />
        </FormField>
        <FormField
          isSkeleton={isLoading}
          label='Casing thickness(mm)'
          htmlFor={`casingThickness-${fields.id}`}
          validationMessages={validationErrors?.casingThickness}
        >
          <TextInput
            isSkeleton={isLoading}
            type='number'
            onWheel={preventChangeOnScroll}
            id={`casingThickness-${fields.id}`}
            value={`${fields.casingThickness ?? ''}`}
            describedBy='casings-group'
            setValue={(value) => setValue('casingThickness', value)}
            isInvalid={!!validationErrors?.casingThickness}
          />
        </FormField>
      </FormFieldRow>
    </>
  )
}
